import { UseQueryOptions, useQuery } from "react-query";

import { merchantsService } from "services";

type UseGetAgentInfoQueryProps = {
	id: string;
	options?:
		| Omit<
				UseQueryOptions<any, unknown, any, string[]>,
				"queryKey" | "queryFn"
		  >
		| undefined;
};

const useGetAgentInfoQuery = ({ id, options }: UseGetAgentInfoQueryProps) =>
	useQuery(["agentInfo", id], () => merchantsService.getAgent(id), {
		enabled: !!id,
		...options,
	});

export default useGetAgentInfoQuery;
